import { useState } from "react";
import { CircleCheck } from "lucide-react";
import { cn } from "@/lib/utils";

export const ReadyFilter = ({ on, onChange, min, count }) => (
  <button type="button" onClick={() => onChange(!on)} data-testid="ready-filter-toggle" aria-pressed={on}
    className={cn("inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-medium transition-colors",
      on ? "border-emerald-500/60 bg-emerald-500/15 text-emerald-300" : "border-[#3F3F46] text-zinc-400 hover:border-emerald-500/50 hover:text-zinc-200")}>
    <CircleCheck className="h-3.5 w-3.5" />Ready to apply · {min}%+
    {on && count != null && <span className="ml-1 rounded-full bg-emerald-500/20 px-1.5 font-mono text-[10px]" data-testid="ready-filter-count">{count}</span>}
  </button>
);

const KEY = "rpopro_ready_filter";
export const useReadyToggle = (page) => {
  const [on, setOn] = useState(() => localStorage.getItem(`${KEY}_${page}`) === "1");
  return [on, (v) => { localStorage.setItem(`${KEY}_${page}`, v ? "1" : "0"); setOn(v); }];
};
